module.exports = __webpack_public_path__ + "static/media/arrow_icon.83e1abe1.svg";